import * as yup from 'yup';

export const numberOfSummarySchema = yup.object({
    number_of_summary: yup.string().label('number_of_summary'),
});

export type numberOfSummarySchemaType = yup.InferType<typeof numberOfSummarySchema>
